export const CLOSE_DOCUMENTS_UPLOAD_FILES = 'CLOSE_DOCUMENTS_UPLOAD_FILES'
export const OPEN_DOCUMENTS_UPLOAD_FILES = 'OPEN_DOCUMENTS_UPLOAD_FILES'
export const START_UPLOAD = 'START_UPLOAD'
